/**
 * Dataset Methods
 * API methods for dataset generation
 */

import { ModelParameters } from '../../../components/ModelConfiguration';
import { TrainingDataSplitData } from '../../../components/TrainingDataSplit';
import { convertUIToBackendFormat, validateModelParameters } from '../../../../../utils/modelParameterUtils';
import { makeRequest, getApiBaseUrl } from '../core';
import { TrainingApiResponse } from '../types';

/**
 * Generate datasets with proper parameter validation
 */
export async function generateDatasets(
  sessionId: string,
  modelConfiguration: ModelParameters,
  trainingDataSplit: TrainingDataSplitData
): Promise<TrainingApiResponse> {

  // Validate parameters before sending
  const modelValidation = validateModelParameters(modelConfiguration);
  if (!modelValidation.isValid) {
    throw new Error(`Model validation failed: ${modelValidation.errors.join(', ')}`);
  }

  // Convert UI parameters to backend format
  let backendModelParams;
  try {
    backendModelParams = convertUIToBackendFormat(modelConfiguration);
  } catch (error) {
    console.error('[DEBUG] Parameter conversion error:', error);
    throw new Error(`Parameter conversion failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }

  // Prepare training split data
  const backendSplitParams = {
    train_ratio: trainingDataSplit.trainPercentage / 100,
    validation_ratio: trainingDataSplit.valPercentage / 100,
    test_ratio: trainingDataSplit.testPercentage / 100,
    shuffle: !trainingDataSplit.random_dat, // Note: inverted logic
    random_state: 42,
    stratify: false
  };

  const requestBody = {
    model_parameters: backendModelParams,
    training_split: backendSplitParams,
    mts_parameters: {
      // Default MTS parameters - will be overridden by backend if session has specific settings
    }
  };

  return makeRequest(`${getApiBaseUrl()}/generate-datasets/${sessionId}`, {
    method: 'POST',
    body: JSON.stringify(requestBody)
  });
}
